import React, { useState } from 'react'
import styled from '@emotion/styled'
import { TableWithFields } from '@types'
import { Filters } from './Filters'
import { Sidebar } from './Sidebar'
import { config } from '../../config'

interface Props {
  children: React.ReactNode
  setParams?: React.Dispatch<React.SetStateAction<TableWithFields>>
}

/**
 * Componente Template per pagine semplici
 * @param props.children {React.ReactNode} content della pagina
 * @param props.setParams {Function=} setter per i filtri della pagina
 * @component
 * @summary Template da utilizzare per le pagine semplici (non di dettaglio) corrispondenti alle voci del menu laterale
 *
 */

export const ChangeTableKeyTemplate: React.FC<Props> = (props) => {
  const { children, setParams } = props

  const [openSidebar, setOpenSidebar] = useState(false)

  const [selectedIndex, setSelectedIndex] = useState<string | undefined>(
    config.dataSet.indexes[0].value
  )

  return (
    <Container>
      {setParams ? (
        <Sidebar
          selectedIndex={selectedIndex}
          setSelectedIndex={setSelectedIndex}
          openSidebar={openSidebar}
          setParams={setParams}
          setOpenSidebar={() => setOpenSidebar(false)}
        />
      ) : (
        <></>
      )}
      {setParams ? (
        <Filters
          selectedIndex={selectedIndex}
          setParams={setParams}
          setOpenSidebar={() => setOpenSidebar(true)}
        />
      ) : (
        <></>
      )}
      {children}
    </Container>
  )
}

//region STYLE
const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 46px 30px 30px 30px;
`
//endregion
